import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { PaymentResultViewTypes } from '~app/modules/checkout/models';

@Injectable({
  providedIn: 'root',
})
export class PaymentResultViewService {
  private readonly viewSubject$ = new BehaviorSubject<PaymentResultViewTypes>(null);

  set view(view: PaymentResultViewTypes) {
    this.viewSubject$.next(view);
  }

  get view$(): Observable<PaymentResultViewTypes> {
    return this.viewSubject$.asObservable();
  }
}
